import React from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import axios from 'axios';

import Constant from '../../Constant';
import { AddCarBrand } from '../../actions/homeAction';

var config = {
	headers: {
		'Content-Type': 'application/json',
		Authorization: localStorage.getItem('loged_In_auth'),
	},
};

class AddCarBrandMaster extends React.Component {
	state = {};
	// onHandleDescriptionChange = value => {
	// 	this.setState({ description: value });
	// };

	handleChange = event => {
		this.setState({ [event.target.name]: event.target.value });
	};

	// handleImageUpload = event => {
	// 	document.getElementById('banner_image_lable').innerHTML = '';
	// 	let element = $('#banner_image').get(0);
	// 	$('#banner_image').empty();
	// 	this.setState({ accepted: element });
	// 	var proof_img = [];
	// 	let obj = {};
	// 	console.log(element.files);
	// 	this.setState({ banner_image: element.files });
	// 	for (var i = 0; i < element.files.length; i++) {
	// 		var file1 = element.files[i];
	// 		var img = document.createElement('img');
	// 		img.className = 'img-100';
	// 		var filePath = URL.createObjectURL(file1);
	// 		img.src = filePath;
	// 		$('#banner_image_lable').append(img);
	// 	}
	// };
	onSave = () => {
		const { dispatch } = this.props;
		const { service, priority, status } = this.state;
		const data = {
			service: service,
			priority: priority,
			status: status,
		};
		dispatch(AddCarBrand(data));
	};
	uploadMedia = event => {
		console.log('this is the image file', event.target.files[0]);

		const file = event.target.files[0];
		var that = this;
		// var form = $('#userImage')[0];

		const reader = new FileReader(file);
		reader.readAsDataURL(file);

		if (file !== undefined) {
			reader.onloadend = () => {
				this.setState({
					// image: URL.createObjectURL(file),
					image: reader.result,
				});
			};
		}
		var data = new FormData();

		// Update the formData object
		data.append('media', file);
		console.log('here upload media', file);
		axios
			.post('https://caravenue.infoware.xyz/api/media/new', data, config)

			.then(res => {
				console.log('this is response', res.data.response.media[0].mediaId);
				Swal.fire({
					title: 'Upload Successfully',
					icon: 'success',
					imageUrl: './assets/images/favicon/android-chrome-192x192.png',
					imageHeight: 100,
					text: '',
					type: 'success',
					confirmButtonColor: '#3ab1f7',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Ok',
				});
				this.setState({ logo: res.data.response.media[0].mediaId });
			})
			.catch(err => {
				console.log(err);
				Swal.fire({
					title:
						err.response !== undefined
							? err.response.data.response.message
							: 'something went wrong Upload again!!!',
					icon: 'error',
					imageUrl: './assets/images/favicon/android-chrome-192x192.png',
					imageHeight: 100,
					text: '',
					type: 'success',
					confirmButtonColor: '#3ab1f7',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Ok',
				});
			});
	};

	render() {
		return (
			// sjfhsdakjf
			<div className=''>
				<div className='col-md-6'>
					<div className='form-group row'>
						<h1>Add Car Brand Master</h1>

						{/* <label className='col-sm-3 col-form-label'>User Type</label> */}
						<div className='col-sm-9'>
							{/* <select
								name='User_type'
								className='form-control'
								value={this.state.User_Type}
								// onChange={this.handleChange}
							>
								<option value='true' name='active'>
									Select From Drop Down
								</option>
								<option value='false' name='inactive'>
									Inactive
								</option>
							</select> */}
						</div>
					</div>
				</div>
				{/* sdjkfj */}
				<div className='card-body'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>
									Car Brand Name
								</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='service'
										id='service'
										placeholder='Car Brand Name'
										onChange={this.handleChange}
										value={this.state.name}
									/>
								</div>
							</div>
						</div>

						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Priority</label>
								<div className='col-sm-9'>
									<input
										type='number'
										className='form-control'
										name='priority'
										id='Priority'
										placeholder='Priority'
										onChange={this.handleChange}
										value={this.state.Priority}
									/>
								</div>
							</div>
						</div>

						{/* <div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Area</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='area'
										id='Visibility'
										placeholder='Area'
										onChange={this.handleChange}
										value={this.state.area}
									/>
								</div>
							</div>
						</div> */}
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Status</label>
								<div className='col-sm-9'>
									<select
										name='status'
										className='form-control'
										value={this.state.status}
										onChange={this.handleChange}>
										<option>Select Status</option>
										<option value='true' name='active'>
											Active
										</option>
										<option value='false' name='inactive'>
											Inactive
										</option>
									</select>
								</div>
							</div>
						</div>
						{/* <div className='col-md-6'>
							<div className='row'>
								<div className='col-sm-3'> Image</div>
								<div className='col-sm-9'>
									<form
										id='userImage'
										name='userImage'
										encType='multipart/form-data'
										className='text-capitalize'>
										<div className='form-group'>
											<input
												accept='image/*'
												onChange={this.uploadMedia}
												id='banner_image'
												type='file'
												className='form-control'
												autoComplete='off'
												name='media'
												data-toggle='tooltip'
												title='Click To Upload Photo'
											/>
											<div id='banner_image_lable' className='pt-2'>
												{this.state.image ? (
													this.state.image !== null ||
													this.state.image !== undefined ||
													this.state.image !== {} ? (
														<img
															src={this.state.image}
															alt=''
															className='img-100'
															onError={e => {
																e.target.src = '';
															}}
														/>
													) : (
														''
													)
												) : (
													''
												)}
											</div>
										</div>
									</form>
								</div>
							</div>
						</div> */}
					</div>

					{/* <div className="row">
            <div className="col-md-12">
              <div className="form-group row">
                <label className="col-sm-2 col-form-label">Description</label>
                <div className="col-sm-10">
                  <ReactQuill
                    value={this.state.description}
                    onChange={this.onHandleDescriptionChange}
                    style={{ height: "200px", marginBottom: '5%' }}
                  />
                </div>
              </div>
            </div>
          </div> */}
					<div className='card-footer'>
						<div className='row float-right p-3'>
							{this.state.isSaving ? (
								<button className='btn btn-grd-disabled mr-2' disabled>
									Saving...!
								</button>
							) : (
								<button
									onClick={this.onSave}
									className='btn btn-grd-disabled mr-2'>
									<i className='icofont icofont-save'></i> Save
								</button>
							)}
							<Link to='/CarBrandMaster' className='btn btn-outline-dark'>
								{' '}
								Cancel{' '}
							</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect()(AddCarBrandMaster);
